import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
 

const GCAutocompleteCheckboxAll = ({
  options = [],
  xDisabled = false,
  xValue = [],
  setValue,
  xtabIndex = "",
  checkBoxFunction=()=>{}
}) => {
  return (
    <div
      className="GCAutocompleteCheckbox"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        multiple
        options={options}
        isOptionEqualToValue={(option, value) => option.Cd === value.Cd}
        disableCloseOnSelect
        getOptionLabel={(option) => option?.Name1}
        renderOption={(props, option, { selected }) => (
           <li {...props} key={option?.Cd}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
              onClick={(event) => {
                  checkBoxFunction(event,option,selected)  
              }}
            />
            {option?.Name1}
          </li>
        )}
        style={{
          width: "100%",
          maxHeight: 100, // Adjust the maximum height as needed
          overflow: "auto",
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label=""
            placeholder=""
            sx={{
              "& input": {
                paddingleft: "0px",
                paddingRight: "0px",
              },
            }}
          />
        )}
        onChange={(event, newValue) => {
           if (!!setValue) {
            setValue(newValue);
          }
        }}
        value={!!xValue ? xValue : []}
        paperprops={{
          style: {
            maxHeight: 200, // Adjust the maximum height as needed
            overflow: "auto",
          },
        }}
        disabled={xDisabled}
      />
      {/* <button onClick={handleReset}>RefreshIcon</button> */}
    </div>
  );
};
export default GCAutocompleteCheckboxAll;
